export const GUID_REGEX = /[A-Fa-f0-9]{8}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{12}/g

export function stripDashesFromGuid(guid) {
  return guid.replace(/-/g, '')
}

export function stripDashesFromAnyGuids(str) {
  const guids = str.match(GUID_REGEX)
  return guids
    ? guids.reduce(
        (strippedStr, guid) =>
          strippedStr.replaceAll(guid, stripDashesFromGuid(guid)),
        str
      )
    : str
}

export default stripDashesFromGuid
